"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import unitrendLogo from "@/public/logo-unitrend.png";
import unitrendWhiteLogo from "@/public/logo-unitrend-white.png";
import Image from "next/image";
import { useTheme } from "next-themes";
import { MailIcon } from "lucide-react";
import React, { useEffect } from "react";

export const ContactCTA: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="w-full">
      <Separator />
      <div className="py-16 bg-slate-50 dark:bg-slate-900 px-6 flex flex-col justify-center items-center text-center gap-3">
        <div data-aos="fade-up">
          <Image
            src={theme === "dark" ? unitrendWhiteLogo : unitrendLogo}
            alt="Unitrend"
            className="w-28 md:w-36 lg:w-44 mx-auto"
          />
        </div>
        {/* 
        <h1
          className="text-2xl md:text-3xl font-semibold text-gray-800 dark:text-gray-100"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Coba layanan Unitrend sekarang
        </h1> */}

        <h2
          className="max-w-2xl text-base md:text-lg text-gray-600 dark:text-gray-300"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Lengkapi <i>Business Intelligence</i> untuk bisnis Anda dengan{" "}
          <i>Comprehensive Insight</i>. Gratis konsultasi 24/7. Coba layanan Unitrend sekarang!
        </h2>

        <div data-aos="fade-up" data-aos-delay="300">
          <Link href="mailto:partnership@unitrend.id">
            <Button
              size="lg"
              className="mt-2 gap-3 animate-pulse hover:animate-none"
            >
              <MailIcon className="size-4" />
              <span>Kontak kami sekarang</span>
            </Button>
          </Link>
        </div>
      </div>
      <Separator />
    </div>
  );
};
ContactCTA.displayName = "ContactCTA";
export default ContactCTA;